import { Box } from '@mantine/core'

export default function RightFloating({ children }: { children?: React.ReactNode }) {
  return <Box className="fixed right-2 top-[35%] z-50">{children}</Box>
}
